/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './FixedNav.css';
import cx from 'classnames'
import moment from 'moment'
import Link from '../Link/Link'

// icon
// @ts-ignore
import icongeo from './iconGeo.png'
// @ts-ignore
import iconplatform from './iconplatform.png'
// @ts-ignore
import iconranking from './iconranking.png'
// @ts-ignore
import iconIn from './iconIN.png'
import { getIndustryList, logout } from '../../controller';

const showList = [
  {
    class: '总榜',
    list: {
      data: [{
        name: 'DBRank100总榜',
        backGround: ['0', '0']
      }],
      title: '总榜导航',
      imgSrc: iconranking,
    }
  }, {
    class: '平台榜',
    list: {
      title: '平台榜导航',
      data: [
        {
          name: '微信',
          backGround: ['0', '0']
        }, {
          name: '微博',
          backGround: ['-18', '0']
        }, {
          name: '今日头条',
          backGround: ['-36', '0']
        }, {
          name: '知乎',
          backGround: ['-54', '0']
        }
      ],
      imgSrc: iconplatform,
    }
  }, {
    class: '地理榜',
    list: {
      title: '地理榜导航',
      imgSrc: icongeo,
      data: [
        {
          name: '国内',
          backGround: ['0', '0'],
          children: [
            {
              name: '安徽',
              color: 'init'
            }, {
              name: '澳门',
              color: 'noInt'
            }, {
              name: '北京',
              color: 'init'
            }, {
              name: '重庆',
              color: 'init'
            }, {
              name: '福建',
              color: 'init'
            }, {
              name: '广西',
              color: 'noInt'
            }, {
              name: '广东',
              color: 'init'
            }, {
              name: '贵州',
              color: 'init'
            }, {
              name: '甘肃',
              color: 'noInt'
            }, {
              name: '黑龙江',
              color: 'init'
            }, {
              name: '河北',
              color: 'init'
            }, {
              name: '河南',
              color: 'init'
            }, {
              name: '湖北',
              color: 'init'
            }, {
              name: '湖南',
              color: 'noInt'
            }, {
              name: '海南',
              color: 'init'
            }, {
              name: '吉林',
              color: 'init'
            }, {
              name: '江苏',
              color: 'init'
            }, {
              name: '江西',
              color: 'init'
            }, {
              name: '辽宁',
              color: 'init'
            }, {
              name: '内蒙古',
              color: 'init'
            }, {
              name: '宁夏',
              color: 'noInt'
            }, {
              name: '青海',
              color: 'noInt'
            }, {
              name: '上海',
              color: 'init'
            }, {
              name: '陕西',
              color: 'noInt'
            }, {
              name: '四川',
              color: 'init'
            }, {
              name: '山东',
              color: 'init'
            }, {
              name: '山西',
              color: 'noInt'
            }, {
              name: '天津',
              color: 'noInt'
            }, {
              name: '台湾',
              color: 'init'
            }, {
              name: '新疆',
              color: 'noInt'
            }, {
              name: '西藏',
              color: 'init'
            }, {
              name: '香港',
              color: 'init'
            }, {
              name: '云南',
              color: 'noInt'
            }, {
              name: '浙江',
              color: 'init'
            }
          ]
        }, {
          name: '国外',
          backGround: ['-18', '0'],
          children: [
            {
              name: '澳大利亚',
              color: 'init'
            }, {
              name: '德国',
              color: 'init'
            }, {
              name: '法国',
              color: 'init'
            }, {
              name: '韩国',
              color: 'init'
            }, {
              name: '荷兰',
              color: 'init'
            }, {
              name: '美国',
              color: 'init'
            }, {
              color: 'init',
              name: '日本',
            }, {
              color: 'init',
              name: '瑞典'
            }, {
              color: 'init',
              name: '西班牙'
            }, {
              color: 'init',
              name: '新加坡'
            }, {
              color: 'init',
              name: '意大利'
            }, {
              color: 'init',
              name: '英国'
            }
          ]
        }
      ]
    }
  }
]

const noChange = [
  'DBRank100总榜',
  '微信',
  '微博',
  '今日头条',
  '知乎'
]

class FixedNav extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      action: '品牌详情',
      toggle: [],
      list: '',
      treeData: [],
      isLoginUser: false,
      tit: '',
      isLoginUserName: '',
      imgSrc: '',
      hasListData: ''
    }

    this.userExits = this.userExits.bind(this)
    this.getIndustryListJson = this.getIndustryListJson.bind(this)
    this.renderUser = this.renderUser.bind(this)
    this.navTitlehandle = this.navTitlehandle.bind(this)
    this.renderDeepItem = this.renderDeepItem.bind(this)
    this.deepItemClickHandle = this.deepItemClickHandle.bind(this)
  }

  componentDidMount() {
    const {item} = this.props

    if (item == '行业榜') {
      this.getIndustryListJson()
      this.setState({ tit: '行业榜导航' })
    } else if (item == '品牌详情') {
      this.setState({ action: '品牌详情', imgSrc: iconIn })
    } else {
      let ac
      for (var key of showList) {
        ac = key['class'] == item ? key['list'] : ac
      }

      if (ac) {
        if (ac.title == '地理榜导航') {
          this.props.doChangeRank('北京')
          this.setState({ action: '北京', toggle: ['国内', '北京'], tit: ac.title, treeData: ac.data, imgSrc: ac.imgSrc })
        } else {
          this.props.doChangeRank(ac.data[0].name)
          this.setState({ action: ac.data[0].name, tit: ac.title, treeData: ac.data, imgSrc: ac.imgSrc })
        }
      }
    }

    const isLogin = localStorage.getItem('isLogin')
    const user = localStorage.getItem('user')
    if (isLogin == 'true' && user) {
      this.setState({
        isLoginUser: true,
        isLoginUserName: user
      })
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.item != this.props.item) {
      if (nextProps.item == '行业榜') {
        this.setState({ toggle: [], action: '', tit: '行业榜导航' })
        this.getIndustryListJson()
      } else if (nextProps.item == '品牌详情' && (noChange.indexOf(nextProps.childrenData) > -1 || this.getQueryString('geo'))) {
        this.setState({ action: '品牌详情', imgSrc: iconIn, toggle: [] })
      } else {
        let ac
        const { item } = nextProps
        for (var key of showList) {
          ac = key['class'] == item ? key['list'] : ac
        }

        if (ac) {

          if (ac.title == '地理榜导航') {
            this.props.doChangeRank('北京')

            this.setState({ action: '北京', toggle: ['国内', '北京'], tit: ac.title, treeData: ac.data, imgSrc: ac.imgSrc })
          } else {
            this.props.doChangeRank(ac.data[0].name)

            this.setState({ action: ac.data[0].name, tit: ac.title, treeData: ac.data, imgSrc: ac.imgSrc })
          }
        }
      }
    }
  }

  componentWillUpdate (nextProps, nextState) {
    if (localStorage.getItem('isLogin') == 'true' && !nextState.isLoginUser || localStorage.getItem('isLogin') == 'false' && nextState.isLoginUser) {

      let hasLogin = localStorage.getItem('isLogin') == 'true' ? true : false

      this.setState({
        isLoginUser: hasLogin,
        isLoginUserName: window.localStorage.getItem('user') || ''
      })
    }
  }

  getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]); return null;
  }

  /**
   * 获取行业列表
   */
  getIndustryListJson() {
    getIndustryList()
      .then(res => {
        if (!res) return alert('数据获取失败，请重新登陆')

        this.setState({
          treeData: res.data,
          action: res.data[0]['name'],
          imgSrc: iconIn,
          hasListData: '行业榜'
        })
        this.props.doChangeSync(res.data[0]['name'], 1)
      })
  }

  /**
   * 退出登陆
   */
  userExits() {
    logout()
      .then(res => {
        // 退出成功后因为该接口被拦截返回的数据为空，未被拦截的时候返回的数据是对象
        if (!res || res.incomplete_results === true) {
          window.localStorage.setItem('isLogin', 'false')
          this.setState({
            isLoginUser: false
          })
        } else {
          alert('退出失败')
        }
      })
  }

  /**
   * 图表dom
   * @param {*} img 
   * @param {String} position 
   */
  renderIcon (img, position) {
    const style = {
      backgroundImage: `url(${img})`,
      backgroundPosition: position
    }
    return <i className={s.icon} style={style}></i>
  }

  /**
   * 点击导航处理事件
   * @param {Object} item 
   * @param {Array} stack 
   * @param {Number} zIndex 
   */
  deepItemClickHandle (item, stack, zIndex) {
    const { brandInfo } = this.props
    this.doAreaInfo(brandInfo.brandList, item.name)
    this.setState({
      action: item.name,
      toggle: stack 
    })
    this.props.doChangeSync(item.name, zIndex)
  }

  /**
   * 递归调用 渲染列表
   * @param {Array} list 
   * @param {Array} names 
   * @param {Number} zIndex 
   */
  renderDeepItem (list, names = [], zIndex = 0) {
    if (!Array.isArray(list)) return null

    const { action, imgSrc, toggle } = this.state
    return list.map(item => {
      const stack = names.concat([item.name])
      
      const activeStatus = action == item.name || toggle.indexOf(item.name) >= 0

      // 当前导航缩进状态
      const style = {
        paddingLeft: `${25 * (zIndex + 1)}px`
      }

      // 当前导航是否是选中状态
      const isActive = cx({
        [s.navItemActive]: activeStatus
      })

      return (
        <div className={cx(s.navItem, s[`navItem${zIndex}`])} key={item.name}>
          <p style={style} className={isActive}
            onClick={() => this.deepItemClickHandle(item, stack, zIndex + 1)}
          >
            {zIndex === 0 && item.backGround && this.renderIcon(imgSrc, `${action == item.name || toggle.indexOf(item.name) >= 0 ? item.backGround[0] : -18}px ${item.backGround[1]}px`)}
            <span>{item.name}</span>
            {action == item.name && <i className={s.activeArrow}></i>}
          </p>
          {this.renderDeepItem(item.children, stack, zIndex + 1)}
        </div>
      )
    })
  }


  renderBrandInfo = () => {
    const { brandInfo } = this.props
    const { action } = this.state
    if (brandInfo) {
      if (brandInfo.brandList && brandInfo.brandList.length < 2) {
        return (
          <div>
            <span className={s.itemUlAc} onClick={() => {
              this.doAreaInfo(brandInfo.brandList)
              this.props.doChangeSync('品牌详情', 1)
              this.setState({ action: '品牌详情', toggle: [] })
            }} >品牌详情
                {action == '品牌详情' && <i className={s.acArrow}></i>}
            </span>

            {brandInfo.mindList && this.renderDeepItem(brandInfo.mindList)}
          </div>
        )
      }

      return <span className={s.itemUlAc}>品牌对比<i className={s.acArrow}></i></span>
    }
  }

  doAreaInfo = (brand, area) => {
    this.props.doChangeUrl([brand, area])
  }

  navTitlehandle() {
    const { treeData } = this.state
    this.props.doChangeSync(treeData.length > 0 ? treeData[0]['name'] : '', 1)
    this.setState({ action: treeData.length > 0 ? treeData[0]['name'] : '', toggle: [] })
  }

  /**
   * 渲染登录和未登录状态
   */
  renderUser() {
    return (
      <div className={s.userWrapper}>
        {this.state.isLoginUser ?
          <div>
            <Link to="/homepage" className={s.userName}>用户：{this.state.isLoginUserName || ''}</Link>
            <Link to="/help" className={s.bigBtn}  >帮助中心</Link>
            <div onClick={this.userExits} className={s.bigBtn}>退出登录</div>
          </div> :
          <div>
            <Link to="/login" className={s.littleBtn} >登录</Link>
            <Link to="/register" className={s.littleBtn}>注册</Link>
          </div>
        }
      </div>
    )
  }

  render() {
    const { action, toggle, treeData, imgSrc } = this.state
    const { item } = this.props

    const navTitle = cx(s.navTitle, {
      [s.navTitleActive]: item != '品牌详情'
    })

    return (
      <div className={s.root}>
        <div className={s.fixedBox}>
          <div className={navTitle} onClick={this.navTitlehandle}>
            {item == '品牌详情' ? <Link to='/industry'>行业榜导航</Link> : <span>{this.state.tit}</span>}
          </div>
          {/* ----------- */}
          <div className={this.state.isLoginUser ? s.rollNavList : s.rollNavListNologin}>
            <ul className={s.conNavList}>

              {item == '品牌详情' && this.renderBrandInfo()}

              {/* {item != '品牌详情' && treeData && this.renderDeepItem(treeData)} */}
              {item != '品牌详情' && treeData && treeData.map((i, index) =>
                <li key={i.name} className={s.posi} >
                  {i.backGround && <i className={s.iconMM} style={{ backgroundImage: `url(${imgSrc})`, backgroundPosition: `${item != '行业榜' ? i.backGround[0] : action == i.name || toggle.indexOf(i.name) >= 0 ? i.backGround[0] : -18}px ${i.backGround[1]}px` }}></i>}
                  <span
                    className={action == i.name || toggle.indexOf(i.name) >= 0 ? cx(s.ac, s.item) : s.item}
                    onClick={() => {
                      if (item != '地理榜') {
                        let toggle = this.state.toggle[0] == i.name ? [] : [(i.name)]
                        this.setState({ action: i.name, toggle: toggle })
                        {/* this.props.doChangeRank(i.name) */ }
                        {/* this.props.doChangeLevel(1) */ }
                        this.props.doChangeSync(i.name, 1)
                      } else {
                        let toggle = this.state.toggle[0] == i.name ? [] : [(i.name)]
                        this.setState({ toggle: toggle })
                      }
                    }}>
                    {i.name}

                    {i.children ? `(${i.children.length})` : null}
                    {action == i.name && <i className={s.acArrow}></i>}
                  </span>
                  {toggle[0] == i.name && i.children
                    && i.children.map((j, index) =>
                      <div key={j.name}>
                        <span key={j.name}
                          className={j.color == 'noInt' ? s.geoNo : j.name == action || toggle.indexOf(j.name) >= 0 ? cx(s.item2, s.ac) : s.item2}
                          onClick={() => {
                            if (item != '地理榜') {
                              let toggle = this.state.toggle[0] == j.name ? [i.name] : [(i.name), j.name]
                              this.setState({ action: j.name, toggle: toggle })
                              this.props.doChangeSync(j.name, 2)
                            } else {
                              if (j.color == 'init') {
                                let toggle = this.state.toggle[0] == j.name ? [i.name] : [(i.name), j.name]
                                this.setState({ toggle: toggle, action: j.name })
                                this.props.doChangeSync(j.name, 1)
                              }

                            }
                          }}
                        >
                          {j.name}
                          {j.children ?
                            `(${j.children.length})`
                            : null}
                          {action == j.name && <i className={s.acArrow2}></i>}
                        </span>
                        {toggle[1] == j.name && j.children
                          && j.children.map((k, index) =>
                            <span key={k.name}
                              className={k.name == action ? cx(s.ac, s.item3) : s.item3}
                              onClick={() => {
                                this.state.toggle[2] = k.name
                                let treeTwoChilden = this.state.toggle[2] == k.name ? this.state.toggle : this.state.toggle.length = 2
                                this.setState({ action: k.name, toggle: treeTwoChilden })
                                this.props.doChangeSync(k.name, 3)
                              }}
                            >
                              {k.name}
                              {action == k.name && <i className={s.acArrow2}></i>}
                            </span>)}
                      </div>)}
                </li>)}
            </ul>
          </div>

          {this.renderUser()}

        </div>
      </div>
    )
  }
}

export default withStyles(s)(FixedNav);



// WEBPACK FOOTER //
// src/components/FixedNav/FixedNav.js